import { TextInput } from "@nokia-csf-uxr/ccfk";
import React, { useRef, useState } from "react";

/**
 * Component to get text value and check if it is right (float, integer, string)
 * valueType : Type of the input value (string, integer or float)
 * value : default value displays
 * onBlur(value, error) : callback function with parameters value of the field and error state to define this one
 */
export default function ValueInput({valueType, value, onChange, onBlur, disabled=false}) {
    
    const checked = useRef(true); // Reference to avoid infinite loop when error state changes
    
    const [val, setVal] = useState(value);
    if(val != value) {
        setVal(value);
    }

    const [error, setError] = useState(false);
    const [errorMsg, setErrorMsg] = useState("Error with this value !");


    const CHECK_VALUE = () => {
        if(!checked.current) {
            checked.current = true;
            let filter;
            switch(valueType) {
                case "integer":
                    filter = /^(\-?[0-9]+)$/.exec(val);
                    if(filter != null) {
                        setError(false);
                    } else {
                        setError(true);
                    }
                    break;
                case "float":
                    filter = /^(\-?[0-9]+)?(\-?\d+\.\d+)?$/.exec(val);
                    if(filter != null) {
                        setError(false);
                    } else {
                        setError(true);
                    }
                    break;
                default:
                    break;
            }
        }
    }

    return (
        <>
            <TextInput disabled={disabled} value={val} onBlur={() => {CHECK_VALUE(); onBlur(val, setError, setErrorMsg)}} onChange={(e) => {setVal(e.target.value); onChange(e.target.value); checked.current = false}} >{val}</TextInput>
            <span className={error ? "text-detail" : "hide-input"}>{errorMsg}</span>
        </>
    );
  }